// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"726":"acf4e829","787":"cb4b6cb6"}[chunkId] + ".chunk.js";
};